<template>
  <div class="preview_c_w">
    <el-dialog :visible="previewImgDialog" append-to-body @close="onClosePreview">
      <img width="100%" :src="previewImgUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'previewImgDialog',
      'previewImgUrl'
    ])

  },

  methods: {
    onClosePreview() {
      this.$emit('closePreviewImg', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.preview_c_w{

}
</style>
